<div class="wrapper">
  @if (fields?.length > 0) {
    <div class="fields-row input-block grid gap-4 grid-cols-2">
      @for (field of fields; track field) {
        @if (field?.type === 'string' || false) {
          <app-text-input
            [controlName]="field?.id"
            [hint]="field?.hintText"
            [label]="field?.label"
            [parentFormGroup]="form"
            [warning]="warningMessages[field?.id]"
            [error]="errorMessages[field?.id]"
            />
        }
        @if (field?.type === 'number' || false) {
          <app-number-input
            [controlName]="field?.id"
            [hint]="field?.hintText"
            [label]="field?.label"
            [parentFormGroup]="form"
            [suffixText]="field?.uom"
            [warning]="warningMessages[field?.id]"
            [error]="errorMessages[field?.id]"
            />
        }
      }
    </div>
  }
  @if (!!form?.controls['comment']) {
    <div
      class="comment-section"
      >
      <app-text-area
        [parentFormGroup]="form"
        controlName="comment"
        label="COMMENT"
        />
    </div>
  }
  @if (selectedMediaFiles?.length) {
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [pictures]="selectedMediaFiles"
      class="pictures-section"
      />
  }
  @if (showLocationSection()) {
    <app-location-station-card
      (onDelete)="deleteLocation()"
      [isEditable]="editable"
      [latitude]="form?.controls?.latitude?.value"
      [longitude]="form?.controls?.longitude?.value"
      [form]="form"
      [recordLabel]="'test'"
      class="location-section"
      />
  }
</div>
